import Slider2 from "../../components/Slider2";
import Formulaire from "../../components/Formulaire";
import Layout from "../../components/Layout";

const Contact = () => {
    return (
        <>
            <Layout>
                <Slider2/>
                <Formulaire/>

                </Layout>
                </>
                );
                }
export default Contact;
